import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from '@mui/material/Skeleton';

// Components
import Alert from '../../Alert';
import OrderCard from '../../OrderCard';

// Styles
import styles from './index.module.sass';
import getCertificados from '../../Queries/getCertificados';

const Certificates = (props) => {
  const { device } = props;
  const { screenSize } = device;
  const { t } = useTranslation('certificates');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    async function certificates() {
      setLoading(true);

      const response = await getCertificados();

      const { tipoMensaje = 'error', certificados = [], mensaje = '' } = response;

      if (tipoMensaje === 'error') {
        setAlertText(mensaje);
        setOpen(true);
      } else {
        setCertificates(certificados);
      }
      setLoading(false);
    }
    certificates();
  }, []);

  const dataCellWidth = (screenSize === 'phone' && '180px') || `${100 / 1}%`;

  return (
    <div id={styles.Notices} className={`${styles[screenSize]} ${styles.certificates}`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <div className={styles.container}>
        <OrderCard>
          <div className={styles.title}>{t('title')}</div>
          {(loading && (
            <div>
              <div className={`${styles.tableContainer}`}>
                <div className={styles.table}>
                  <div className={`${styles.row} ${styles.tableHeader}`}>&nbsp;</div>
                  <Skeleton variant='rectangular' className={styles.loadingText} />
                  <Skeleton variant='rectangular' className={styles.loadingText} />
                  <Skeleton variant='rectangular' className={styles.loadingText} />
                </div>
              </div>
            </div>
          )) || (
            <div>
              <div className={`${styles.tableContainer}`}>
                <div className={styles.table}>
                  <div className={`${styles.row} ${styles.tableHeader}`}>&nbsp;</div>
                  {certificates.map((val, key) => {
                    const cell = (
                      <div className={styles.cell} style={{ width: dataCellWidth }} key={key}>
                        <a href={val} target='_blank' rel='noopener noreferrer'>
                          {t('download')}
                        </a>
                      </div>
                    );
                    return cell;
                  })}
                </div>
              </div>
            </div>
          )}
        </OrderCard>
      </div>
    </div>
  );
};

export default Certificates;
